import { render, staticRenderFns } from "./servercard.vue?vue&type=template&id=87839d7e&scoped=true"
import script from "./servercard.vue?vue&type=script&lang=js"
export * from "./servercard.vue?vue&type=script&lang=js"
import style0 from "./servercard.vue?vue&type=style&index=0&id=87839d7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87839d7e",
  null
  
)

export default component.exports